/**
 * @fileoverview GET handler for the "/engagement/remote_segment_search" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryInfiniteFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementRemoteSegmentSearch } from "./constants";
import type { EngagementRemoteSegmentSearchResult, GetEngagementRemoteSegmentSearchParams } from "./types";

export const getEngagementRemoteSegmentSearch = reactQueryInfiniteFetcherAdapter(
  engagementRemoteSegmentSearch,
  (
    signal: AbortSignal,
    [params]: [GetEngagementRemoteSegmentSearchParams],
    pageParam: number | null
  ): Promise<EngagementRemoteSegmentSearchResult> => {
    const { appGroupId, query, limit, skipCount, excludeList } = params;
    return fetch(
      "/engagement/remote_segment_search",
      "GET",
      {
        app_group_id: appGroupId,
        query,
        limit,
        // prefer pageParam over skipCount in the case this endpoint is used without infinite query
        skip_count: pageParam ?? skipCount ?? 0,
        exclude_list: excludeList,
      },
      { signal }
    );
  }
);
